import { render, staticRenderFns } from "./WeaponDiscipline.vue?vue&type=template&id=1fde5c62&scoped=true"
import script from "./WeaponDiscipline.vue?vue&type=script&lang=js"
export * from "./WeaponDiscipline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde5c62",
  null
  
)

export default component.exports